import React, { FC } from "react";
import MastercardSVG from "./mastercard.svg";

type Props = JSX.IntrinsicAttributes;

export const MastercardIcon: FC<Props> = (props) => {
  return <MastercardSVG {...props} />;
};
